import LegalInfo from "./LegalInfo";
export default LegalInfo;
